import { useHasPermission } from '../../hooks/useHasPermission';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/invoices/invoicePageHeader.css';

const InvoicePageHeader = ({setOpenAddInvoice}) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const hasInvoiceCreatePermission = useHasPermission('facture_create');

    const handleAddInvoice = useCallback(() => {
        setOpenAddInvoice(true);
    }, [setOpenAddInvoice]);

    return (
        <Box className='invoice_headre_main_container'>
            <Box className='invoice_headre_title_box'>
                <Typography className='invoice_headre_page_title'>Factures</Typography>
            </Box>
            {(isDesktop && hasInvoiceCreatePermission) &&
                <Box className='invoice_headre_action_box' onClick={handleAddInvoice}>
                    <Iconify className='invoice_headre_add_icon' icon={"ic:baseline-plus"} />
                    <Typography className='invoice_headre_action_title'>{t("addInvoiceDialogeTitle")}</Typography>
                </Box>
            }
            {(!isDesktop && hasInvoiceCreatePermission) &&
                <Box className='invoice_headre_action_box'>
                    <Iconify className='invoice_headre_add_icon' icon={"ic:baseline-plus"} onClick={handleAddInvoice} />
                </Box>
            }
        </Box>

    );
};

export default React.memo(InvoicePageHeader);